import api from '@/api';
import type { RevisitSoonTrove } from '@/api/revisitSoon';

export interface WelcomeBackWorkspace {
  sid: string;
  name: string;
  lastActiveAt: string | null;
  eventCount: number;
}

export interface WelcomeBackTaskSummary {
  id: string;
  title: string;
  sid: string;
  dueDate: string | null;
}

export interface WelcomeBackResponse {
  status: 'success';
  activityMemoryEnabled: boolean;
  yesterdayUtc: string;
  workspaces: WelcomeBackWorkspace[];
  unfinished: {
    revisitOverdue: RevisitSoonTrove[];
    revisitUpcoming: RevisitSoonTrove[];
    tasksDueSoon: WelcomeBackTaskSummary[];
  };
  primaryContinueSid: string | null;
}

export async function fetchWelcomeBack(): Promise<WelcomeBackResponse | null> {
  const res = await api.get<WelcomeBackResponse>('/activity/welcome-back');
  if (res.data?.status !== 'success') return null;
  return res.data;
}

export async function postActivityEvents(
  events: Array<{
    type: string;
    sid?: string;
    entityType?: string;
    entityId?: string;
    meta?: Record<string, unknown>;
  }>
): Promise<void> {
  if (events.length === 0) return;
  await api.post('/activity/events', { events });
}

export async function patchActivityMemoryEnabled(enabled: boolean): Promise<void> {
  await api.patch('/activity/memory-settings', { activityMemoryEnabled: enabled });
}

export interface WorkMemoryGates {
  welcomeBackViews: number;
  continueClicks: number;
  resurfaceShown: number;
  resurfaceClicked: number;
  continueCtr: number;
  resurfaceCtr: number;
  wave2AiThemesEnabled: boolean;
}

export async function fetchWorkMemoryGates(): Promise<WorkMemoryGates | null> {
  const res = await api.get<{ status: string; gates?: WorkMemoryGates }>('/activity/work-memory-gates');
  if (res.data?.status !== 'success' || !res.data.gates) return null;
  return res.data.gates;
}
